



















import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";
import { SXSurvey } from "../gobl.bundle";

@Component
export default class WSurveysSearch extends BaseComponent {
	searching: boolean = false;
	results: SXSurvey[] = [];
	search: string = "";

	onSearch(search: string) {
		let x = this,
			always = () => (x.searching = false);
		x.searching = true;
		x.search = search;

		x.$services.surveys.getAll(
			{
				filters: {
					[SXSurvey.COL_NAME]: [["like", `%${search}%`]]
				}
			},
			function(response) {
				always();
				x.results = response.data.items;
			},
			function(response) {
				always();
				x.results = [];
			},
			false
		);
	}
}
